import BaseFileEditorMixin from "@/modules/core/file/protected/BaseFileEditorMixin";
import service from "./CreditAssignmentFileService";
import FileForm from "./CreditAssignmentFileForm";

export default {
  mixins: [BaseFileEditorMixin],

  created() {
    this.FileForm = FileForm;
    this.fileContextServerPath = "credit-assignments/files";
    this.requestContextServerPath = "credit-assignments/requests";
    //this.externalContext = 'CREDIT_ASSIGNMENT_FILE';
  },

  methods: {
    getService() {
      return service;
    }
  }
};
